







































































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { onMounted, Ref, ref } from "@vue/composition-api";
import { UseLoading } from "@/common/composition/loading";
import { get_justification_by_id } from "@/views/customize/in-motion/justification/data/api";
import { Justification } from "@/views/customize/in-motion/justification/data/model";
import { getEventById } from "@/common/api/entities.api";
import Spinner from "@/components/Spinner.vue";
import { delayBy } from "@/fp";

export default Vue.extend({
  components: {
    Modal,
    Spinner,
  },
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "50rem",
      height: "auto",
      withTopRightCloseBtn: true,
    };

    const justification: Ref<Justification | null> = ref(null);

    const [is_loading, set_loading] = UseLoading(false).as_arr();

    const load_justification = async (id: string) => {
      const res = await get_justification_by_id(id);
      if (res.success) {
        justification.value = res.value;
      }
    };

    onMounted(async () => {
      set_loading(true);
      const { justification_id, event_id } = props.modalData as {
        justification_id: string;
        event_id: string;
      };
      if (justification_id) {
        await load_justification(justification_id);
      } else {
        const event_res = await getEventById(event_id);
        if (event_res.success) {
          await load_justification(event_res.value.justification.id);
        }
      }
      set_loading(false);
    });

    return {
      config,
      is_loading,
      justification,
    };
  },
});
